<template>
    <b-container fluid class="overview">
        <h1 class="text-left">{{ $t('nedglobeServices.tables.menuitem') }}</h1>
        <br />
        <div class="row">
            <!-- Search field -->
            <search-box
                id="searchNedGlobeServicesTables"
                @input="$_onInput"
                :info="$t('searchInfo')"
                :autofocus="true"
                :value="searchText"
                :saveInState="true"
                class="mb-2"
            >
            </search-box>
            <b-link class="px-1 pt-2" @click="$_clearFilters()">
                {{ $t('clearFilter') }}
            </b-link>
        </div>
        <div>
            <x-checkbox
                :name="`relationFieldCaseSensitive1`"
                :text="$t('nedglobeServices.tables.showNotUsedTablesOnly')"
                v-show="dataLoaded"
                v-model="ShowNotUsedTablesOnly"
                class="mb-2"
            >
            </x-checkbox>
        </div>
        <!-- Overview Table -->
        <div>
            <b-table
                striped
                hover
                small
                outlined
                bordered
                :sticky-header="btableMaxHeight"
                v-show="dataLoaded"
                :items="filteredRecords"
                :fields="fields"
                sort-by="Name"
                :sort-desc="false"
                sort-icon-left
                class="mb-1"
                id="table-nedglobe-services-tables"
            >
                <template v-slot:cell(selected)="row">
                    <div
                        @click.stop
                        class="
                            h-100
                            w-100
                            d-flex
                            align-items-center
                            justify-content-center
                            pl-1
                        "
                    >
                        <b-form-checkbox
                            :id="`${row.item.Name}selected`"
                            :name="`${row.item.Name}selected`"
                            v-model="row.item.selected"
                        >
                        </b-form-checkbox>
                    </div>
                </template>
                <template v-slot:head(selected)="">
                    <x-checkbox
                        id="selectAll"
                        name="selectAll"
                        :state="null"
                        :value="isAllSelected"
                        @change="$_onSelectAll($event)"
                        :indeterminate="isIndeterminate"
                        :expandClickArea="true"
                        class="pl-1 mt-1"
                    >
                    </x-checkbox>
                </template>

                <template v-slot:cell(content)="{ item }">
                    <!-- Button to open modal with table content-->
                    <b-button
                        size="sm"
                        variant="secondary"
                        @click="$_showContent(item.Name)"
                    >
                        {{ $t('nedglobeServices.tables.showContent') }}
                    </b-button>
                </template>
            </b-table>
            <base-button
                v-show="dataLoaded"
                id="imageLoaderDeleteBtn"
                class="py-2 sticky-bottom fixed-bottom"
                :iconClass="`fa fa-trash-alt`"
                @click="$_removeTables"
                :text="$t('nedglobeServices.tables.delete')"
                :disabled="!IsSelectedAndNotUsed"
            >
            </base-button>
        </div>
        <!-- No content for overview -->
        <div
            v-if="(!this.records || this.records.length === 0) && !loading"
            class="col-md-12"
        >
            <span>{{ $t('nedglobeServices.tables.nonePresent') }}</span>
        </div>
        <table-content
            :launchModal="launchTableContentModal"
            :tableName="tableName"
        />
    </b-container>
</template>

<script>
    import { nprogress } from '../../services/utilities';
    import SearchBox from '../../components/SearchBox.vue';
    import refcodeMixin from '../../components/Mixins/Refcodes/refcodeMixin.vue';
    import ModalMixin from '../../components/Mixins/ModalMixin.vue';
    import { mapState } from 'vuex';
    import XCheckbox from '../../components/BaseComponents/x-checkbox.vue';
    import BaseButton from '../../components/BaseComponents/base-button.vue';
    import TableContent from './NedGlobeServicesTableContent.vue';

    export default {
        name: 'NedGlobeServicesTablesOverview',

        mixins: [refcodeMixin, ModalMixin],

        //props: {
        //},

        components: {
            'search-box': SearchBox,
            'x-checkbox': XCheckbox,
            'base-button': BaseButton,
            'table-content': TableContent
        },
        data: function () {
            return {
                fields: [
                    {
                        key: 'selected',
                        tdClass:
                            'user-chkbox-cell text-center align-middle p-0 m-0',
                        thClass: 'text-center align-middle',
                        thStyle: { border: 0, width: '20px' }
                    },
                    {
                        key: 'Name',
                        label: this.$t('nedglobeServices.tables.columnNameTitle'),
                        sortable: true,
                        thStyle: { border: 0, width: '100px' }
                    },
                    {
                        key: 'Layer',
                        label: this.$t('nedglobeServices.tables.columnLayerTitle'),
                        sortable: true,
                        thStyle: { border: 0, width: '300px' }
                    },
                    {
                        key: 'TableResult',
                        label: this.$t(
                            'nedglobeServices.tables.columnTableResultTitle'
                        ),
                        sortable: true,
                        thStyle: { border: 0, width: '300px' }
                    },
                    {
                        key: 'content',
                        label: '',
                        thStyle: { border: 0, width: '60px' }
                    }
                ],
                priorityTypes: null,
                records: [],
                tablesToDeleteList: [],
                searchText: '',
                ShowNotUsedTablesOnly: false,
                btableMaxHeight: `${(window.innerHeight - 300).toString()}px`,
                // loading: during load no test-message shown that there are no messages yet
                loading: true,
                launchTableContentModal: false,
                tableName: ''
            };
        },

        computed: {
            ...mapState(['userInfo']),

            dataLoaded() {
                return this.records.length > 0;
            },

            filteredRecords() {
                let records = this.records;
                // Filter records
                if (this.ShowNotUsedTablesOnly) {
                    records = records.filter((record) => {
                        return Object.keys(record).some(
                            (key) =>
                                record['Layer'].length === 0 &&
                                record['TableResult'].length === 0
                        );
                    });
                }
                if (this.searchText && this.searchText.length > 0) {
                    const tokens = this.searchText.toLowerCase();
                    records = records.filter((record) => {
                        return Object.keys(record).some((key) =>
                            record[key].toString().toLowerCase().includes(tokens)
                        );
                    });
                }
                return records;
            },
            hasTableSelection() {
                return !!this.filteredRecords.find(
                    ({ selected }) => selected === true
                );
            },
            isAllSelected() {
                return (
                    this.filteredRecords.length > 0 &&
                    this.filteredRecords.every(({ selected }) => selected === true)
                );
            },
            isIndeterminate() {
                return !this.isAllSelected && this.hasTableSelection;
            },
            IsSelectedAndNotUsed() {
                if (!this.hasTableSelection) {
                    return false;
                }
                // controll if all selected rows
                // not used in themalayers and tableresults
                const selectedrecs = this.filteredRecords.filter(
                    (fr) =>
                        fr.selected &&
                        (fr.Layer.length !== 0 || fr.TableResult.length !== 0)
                );
                return selectedrecs.length === 0;
            }
        },

        async created() {
            nprogress.start();
            this.loading = true;
            // Get all the data from the backend
            await this.$_getData();
            this.loading = false;
            nprogress.done();
        },
        mounted() {
            // to update b-table max-height to have a freeze header (sticky-header makes fixed max-height only regardless the screen height)
            // placed a new issue in Git, see if we get any response.
            this.$nextTick(() => {
                window.addEventListener('resize', () => {
                    // debugger
                    this.btableMaxHeight = `${(
                        window.innerHeight - 300
                    ).toString()}px`; // where offset is some kind of constant margin you need from the top
                });
            });
        },
        beforeDestroy() {
            window.removeEventListener('resize', () => {});
        },

        methods: {
            $_onInput(searchText) {
                this.searchText = searchText;
            },
            $_clearFilters() {
                this.$_onInput('');
            },
            $_clearSelection() {
                this.$_onSelectAll(false);
            },
            async $_getData() {
                let result = null;
                result = await this.$store.dispatch('useApiData', {
                    name: 'GetAllTablesAndWhereUsed'
                });
                this.records = result?.data?.map((item) => {
                    return {
                        selected: false,
                        Name: item.tableName,
                        Layer: item.tableLayers,
                        TableResult: item.tableSearchResults
                    };
                });
            },
            $_onSelectAll(event) {
                this.filteredRecords.forEach((record) => {
                    record.selected = event;
                });
            },
            async $_removeTables() {
                const selectedrecs = this.filteredRecords.filter(
                    (fr) =>
                        fr.selected &&
                        (fr.Layer.length === 0 || fr.TableResult.length === 0)
                );
                const tableCount = selectedrecs.length;
                if (tableCount === 0) {
                    return;
                }
                let tableNames = selectedrecs.map((a) => a.Name);
                const wantsToContinue = await this.msgBoxConfirm({
                    message: this.$t(
                        'nedglobeServices.tables.deleteTablesConfirmation'
                    )
                });
                if (!wantsToContinue) {
                    return;
                }
                let results = await this.$store.dispatch('useApiData', {
                    name: 'DeleteGeoServerTables',
                    data: {
                        tableNames
                    }
                });
                let dispMessage = '';
                if (results.data.length === 0) {
                    dispMessage =
                        tableCount == 1
                            ? this.$t(
                                  'nedglobeServices.tables.tableDeletedConfirmation'
                              )
                            : this.$t(
                                  'nedglobeServices.tables.tablesDeletedConfirmation'
                              );
                } else {
                    dispMessage =
                        tableCount == 1
                            ? this.$t(
                                  'nedglobeServices.tables.tableNotDeletedConfirmation'
                              )
                            : this.$t(
                                  'nedglobeServices.tables.tablesNotDeletedConfirmation'
                              );
                    dispMessage += '\r\n';
                    dispMessage += results.data.join(', ');
                }
                let msgData = {
                    message: dispMessage,
                    variant: 'success',
                    autoHideDelay: 2500,
                    noCloseButton: true
                };
                this.showToast(msgData);
                this.$_getData();
            },
            $_showContent(tableName) {
                // Set chosen tablename and launch modal content view
                this.tableName = tableName;
                this.launchTableContentModal = !this.launchTableContentModal;
            }
        },
        watch: {
            // Clear selection when any of the filter items changes
            searchText() {
                this.$_clearSelection();
            },
            ShowNotUsedTablesOnly() {
                this.$_clearSelection();
            }
        }
    };
</script>

<style>
.user-chkbox-cell {
    height: 1px;
    cursor: default;
}
.tableFixHead {
    overflow-y: auto; /* make the table scrollable if height is more than 200 px  */
    height: 90%; /* gives an initial height of 200px to the table */
}

.tableFixHead thead-class th {
    position: sticky; /* make the table heads sticky */
    top: 0px; /* table head will be placed from the top of the table and sticks to it */
}

table {
    border-collapse: collapse; /* make the table borders collapse to each other */
    width: 100%;
}

thead-class,
td {
    padding: 8px 16px;
    border: 1px solid #ccc;
    position: sticky;
}

thead-class {
    background: #eee;
}
</style>
